module.exports = __webpack_public_path__ + "img/gushi-logo.1c4167b4.png";